import React, { useRef } from "react";
import { MessageSquare } from "lucide-react";
import { Comment } from "./CommentThread";

interface Props {
  pageId: string;
  comments: Comment[];
  zoom: number;
  commentMode: boolean;
  selectedCommentId: string | null;
  onDocumentClick: (xFrac: number, yFrac: number) => void;
}

const CommentLayer: React.FC<Props> = ({
  pageId,
  comments,
  zoom,
  commentMode,
  selectedCommentId,
  onDocumentClick,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const pageComments = comments.filter((c) => c.page_id === pageId);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if ((e.target as HTMLElement).closest("[data-marker]")) return;
    if (!commentMode) return;
    const rect = containerRef.current!.getBoundingClientRect();
    onDocumentClick(
      (e.clientX - rect.left) / rect.width,
      (e.clientY - rect.top) / rect.height,
    );
  };

  return (
    <div
      ref={containerRef}
      className={`absolute inset-0 ${commentMode ? "cursor-crosshair" : "cursor-default"}`}
      style={{ zIndex: 20 }}
      onClick={handleClick}
    >
      {pageComments
        .filter((c) => c.id === selectedCommentId)
        .map((comment) => (
          <div
            key={comment.id}
            data-marker
            className="absolute"
            style={{
              left: `${comment.x_position * 100}%`,
              top: `${comment.y_position * 100}%`,
              transform: `translate(-50%, -50%) scale(${1 / zoom})`,
              transformOrigin: "center center",
              zIndex: 21,
            }}
          >
            <div className="absolute inset-0 rounded-full animate-ping bg-[#1d365d] opacity-40" />
            <div className="relative w-6 h-6 rounded-full flex items-center justify-center shadow border-2 border-white bg-[#1d365d] scale-110">
              <MessageSquare size={11} className="text-white" />
            </div>
          </div>
        ))}
    </div>
  );
};

export default CommentLayer;
